// extracted by mini-css-extract-plugin
export default {"addToCartControl":"FZ-z","giftCard":"GZ-z","btnContainer":"HZ-z","cartButton":"IZ-z","disabled":"JZ-z"};